import { FC, ReactNode } from 'react';
import { Popover } from '@mui/material';

export interface MetricsSelectorPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: ReactNode;
}

/**
 * Shared Popover wrapper for MetricsSelector
 * Provides consistent positioning and styling across Dashboard and Analytics pages
 */
export const MetricsSelectorPopover: FC<MetricsSelectorPopoverProps> = ({ open, anchorEl, onClose, children }) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          className: 'rounded-lg overflow-visible mt-2',
          style: {
            overflow: 'visible',
            background: 'none',
            boxShadow: 'none',
          },
        },
      }}
    >
      {children}
    </Popover>
  );
};
